"use client"

import Title from "@/components/common/Typography/Title"
import { tourActions } from "@/lib/redux/features/tour/reduce"
import { useAppDispatch, useAppSelector } from "@/lib/redux/hooks"
import { Button, Col, Row } from "antd"
import { FC } from "react"
import { useTranslation } from "react-i18next"

const DURATION_OPTIONS: {
  key: string
  labelKey: string
  range: [number, number]
}[] = [
  { key: "1-2", labelKey: "tour.duration_1_2", range: [1, 2] },
  { key: "3-4", labelKey: "tour.duration_3_4", range: [3, 4] },
  { key: "5", labelKey: "tour.duration_5", range: [5, 5] },
  { key: "6+", labelKey: "tour.duration_6_plus", range: [6, 99] },
]

const ListDuration: FC<{ onChange?: () => void }> = ({ onChange }) => {
  const durationDays = useAppSelector((state) => state.tour.formSearch.durationDays)
  const dispatch = useAppDispatch()
  const { t } = useTranslation()

  const isActive = (range: [number, number]) =>
    durationDays?.[0] === range[0] && durationDays?.[1] === range[1]

  return (
    <div className="tour-filter-duration">
      <Row
        className="flights__list--filter-input--box tour-filter-duration__title"
        justify="space-between"
        align="middle"
      >
        <Col>
          <Title level={5} style={{ margin: 0 }}>
            {t("tour.duration_days_filter")}
          </Title>
        </Col>
        {durationDays && (
          <Col>
            <Button
              type="text"
              onClick={() => {
                dispatch(tourActions.setTourDurationDays(undefined))
                onChange?.()
              }}
            >
              {t("common.reset")}
            </Button>
          </Col>
        )}
      </Row>
      <Row gutter={[8, 8]} className="tour-filter-duration__grid">
        {DURATION_OPTIONS.map((option) => (
          <Col key={option.key} span={12}>
            <Button
              block
              type="default"
              className={`tour-filter-duration__btn${isActive(option.range) ? " tour-filter-duration__btn--active" : ""}`}
              onClick={() => {
                const next = isActive(option.range) ? undefined : option.range
                dispatch(tourActions.setTourDurationDays(next))
                onChange?.()
              }}
            >
              {t(option.labelKey)}
            </Button>
          </Col>
        ))}
      </Row>
    </div>
  )
}

export default ListDuration
